import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const OrderSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [orderDetails, setOrderDetails] = useState(null);
  
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const orderId = urlParams.get('order_id');
    const paymentMethod = urlParams.get('payment_method');
    
    if (!orderId) {
      navigate('/');
      return;
    }
    
    setOrderDetails({
      orderId,
      paymentMethod
    });
  }, [location, navigate]);

  if (!orderDetails) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-black mx-auto"></div>
          <p className="mt-4">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="text-3xl font-light mb-2">Order Successful!</h1>
          <p className="text-black">Your order has been placed successfully.</p>
        </div>

        <div className=" rounded-lg p-6 mb-8">
          <h2 className="text-lg font-medium mb-4">Order Details</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <p className="text-sm text-black">Order Number</p>
              <p className="font-medium">#{orderDetails.orderId}</p>
            </div>
            <div>
              <p className="text-sm text-black">Date</p>
              <p className="font-medium">{new Date().toLocaleDateString()}</p>
            </div>
            <div>
              <p className="text-sm text-black">Payment Method</p>
              <p className="font-medium">
                {orderDetails.paymentMethod === 'cod' ? 'Cash on Delivery' : 'Other'}
              </p>
            </div>
          </div>
        </div>

        {orderDetails.paymentMethod === 'cod' && (
          <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-8">
            <h3 className="text-lg font-medium mb-2 text-green-800">Cash on Delivery</h3>
            <p className="text-green-700">
              Your order will be delivered to your address. Please have the exact amount ready for payment upon delivery.
            </p>
          </div>
        )}

        <div className="text-center space-y-4">
          <p className="text-black">
            We've sent an order confirmation email to your email address. You can track your order status in your account.
          </p>
          <div className="space-x-4">
            <button
              onClick={() => navigate('/')}
              className="bg-black text-white px-6 py-2 rounded"
            >
              Continue Shopping
            </button>
            <button
              onClick={() => navigate('/my-account/orders')}
              className="border border-black text-black px-6 py-2 rounded transition-colors"
            >
              View Orders
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;